import React from 'react';

import AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

interface PreviewPanelBodyProps {
	children: React.ReactNode;
	parentProduct?: string;
	panelType?: string;
	analyticsClient?: AnalyticsWebClient | undefined | null;
}

const styles = cssMap({
	wrapper: {
		flexGrow: 1,
		overflow: 'auto',
	},
});

export const PreviewPanelBody = ({ children, analyticsClient, parentProduct, panelType }: PreviewPanelBodyProps) => {
	React.useEffect(() => {
		if (analyticsClient) {
			analyticsClient.sendTrackEvent({
				action: 'viewed',
				actionSubject: 'preview-panel',
				actionSubjectId: 'preview-panel-view',
				source: 'preview-panel',
				attributes: {
					parentProduct,
					panelType
				},
			})
		}
	}, [analyticsClient, parentProduct, panelType])

	return (
		<Box xcss={styles.wrapper} paddingInlineStart="space.300">
			{children}
		</Box>
	);
};
